import React from 'react';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/src/core/styles.scss';
import { Carousel, Video } from './styles';
import { IDestinationBanner } from 'interfaces/IDestinationsBannerts';
import { Arrow } from 'common/BannerCarousel/styles';
import { useHistory } from 'react-router-dom';
import Button from 'components/Buttom/Button';

interface Props {
  banners?: IDestinationBanner[];
  applyGradient?: boolean;
  destinationSlug?: string;
}

const orderByIdAsc = (a: IDestinationBanner, b: IDestinationBanner) => a.id - b.id;

const DestinationsCarousel = (props: Props): JSX.Element => {
  const banners = props.banners?.sort(orderByIdAsc);
  const history = useHistory();

  const settings = {
    infinite: true,
    organicArrows: false,
    fillParent: false,
    buttonContentRight: <Arrow>&gt;</Arrow>,
    buttonContentLeft: <Arrow>&lt;</Arrow>,
  };

  return (
    <Carousel>
      <AwesomeSlider {...settings}>
        {banners?.map(banner => {
          return (
            <div key={banner.id}>
              <div
                className="destination-carousel"
                style={{
                  background: `url(${banner.image}) center top / cover no-repeat`,
                }}>
                <span className="description">
                  {(banner as any).title || banner.description}
                  <br />
                  <br />
                  {props.destinationSlug && (
                    <Button
                      text="CONHEÇA MAIS"
                      onClick={() => history.push(`/what-to-do/itineraries/${props.destinationSlug}`)}
                    />
                  )}
                </span>
                {banner.image.endsWith('.mp4') ? (
                  <Video src={banner.image} autoPlay loop muted playsInline />
                ) : (
                  <div
                    style={{
                      ...(props.applyGradient !== false && {
                        background: 'linear-gradient(90deg, rgba(13,74,155,0.9) 0%, rgba(13,74,155,0) 100%)',
                      }),
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </AwesomeSlider>
    </Carousel>
  );
};

export default DestinationsCarousel;
